import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { Link } from "react-router-dom";
import { MdmTable } from "src/components/MdmTable";
import { PageLayout } from "src/components/PageLayout";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { workflowsPageStore as pageStore } from "./workflowsPageStore";

export const WorkflowsPage: React.FC = observer(() => {
  const tools = (
    <>
      <RtColumnsSettingsButton store={pageStore.table} />
      <Link to={makeUrl(PageUrl.managementWorkflowNew)}>
        <Button icon={<PlusCircleOutlined />} type="primary">
          Создать
        </Button>
      </Link>
    </>
  );

  return (
    <PageLayout title="Рабочие потоки">
      <ToolBox2 extraTools={tools} paddingMode="page">
        <MdmTable
          store={pageStore.table}
          columns={pageStore.columns}
          resizableColumns
          rowClick={{
            type: "link",
            builder: ({ id }) =>
              makeUrl(PageUrl.managementWorkflowCard, { id }),
          }}
        />
      </ToolBox2>
    </PageLayout>
  );
});
